import { useNavigate } from "react-router-dom";
import { ResponsiveBlockSwitcher } from "@/shared/Components";
import { appRouterPaths } from "@/services/navigation";
import { Desktop, Mobile } from "./components";

export const SuccessStep = () => {
  const navigate = useNavigate();

  const onClick = () => {
    navigate(appRouterPaths.logIn);
  };

  return (
    <ResponsiveBlockSwitcher
      mobile={<Mobile onClick={onClick} />}
      desktop={<Desktop onClick={onClick} />}
    />
  );
};
